"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasCommisionBeforePurchase = exports.getCommissionBeforePurchaseAmount = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _config = require("../config");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var hasCommisionBeforePurchase = function hasCommisionBeforePurchase(cartItems) {
  return Boolean(_lodash.default.find(cartItems, function (item) {
    return !item.is_primary_product &&
    // item.salable_item_class === COMMISSION_CLASS_NAME &&
    item.salable_item.displayed_time === _config.COMMISSION_BEFORE_PURCHASE_TIME;
  }));
};
exports.hasCommisionBeforePurchase = hasCommisionBeforePurchase;
var getCommissionBeforePurchaseAmount = function getCommissionBeforePurchaseAmount(cartItems) {
  if (hasCommisionBeforePurchase(cartItems)) {
    return cartItems === null || cartItems === void 0 ? void 0 : cartItems.filter(function (item) {
      return !item.is_primary_product &&
      // item.salable_item_class === COMMISSION_CLASS_NAME &&
      item.salable_item.displayed_time === _config.COMMISSION_BEFORE_PURCHASE_TIME;
    }).map(function (item) {
      return item.total_price;
    }).reduce(function (a, b) {
      return a + b;
    }, 0);
  }
  return undefined;
};
exports.getCommissionBeforePurchaseAmount = getCommissionBeforePurchaseAmount;